import { useEffect, useState } from "react";
import axios from "../../../axios";

const PaymentSetting = () => {
  const [openWeb, setOpenWeb] = useState(false);
  const [openApp, setOpenApp] = useState(false);

  const [selectedWeb, setSelectedWeb] = useState("Select Web Gateway");
  const [selectedApp, setSelectedApp] = useState("Select App Gateway");

  const [loading, setLoading] = useState(false);
  const [settingId, setSettingId] = useState(""); // <-- store id here

  const [webVisible, setWebVisible] = useState(true);
const [appVisible, setAppVisible] = useState(true);

const [webVideoLink, setWebVideoLink] = useState("");
const [appVideoLink, setAppVideoLink] = useState("");
const [showCheckOutPage, setshowCheckOutPage] = useState(true);
const [showGatewayPaymentButton, setShowGatewayPaymentButton] = useState(true);
const [showWebsitePaymentButton, setShowWebsitePaymentButton] = useState(true);



  const options = [
    "razorpay", "phonepe", "instamojo", "haoda", "payu", "nimbbl","paypal","strip"
  ];
  // Fetch existing settings when component loads
  useEffect(() => {
    const fetchSetting = async () => {
      try {
        const res = await axios.get("getGetwaySetting");

        if (Array.isArray(res.data.result) && res.data.result.length > 0) {
          const latest = res.data.result[res.data.result.length - 1]; // newest one

          setSettingId(latest._id);
          setSelectedWeb(latest.upiGatewayWeb || "Select Web Gateway");
          setSelectedApp(latest.upiGateway || "Select App Gateway");
          setShowGatewayPaymentButton(latest.showGatewayPaymentButton ?? true);
          setShowWebsitePaymentButton(latest.showWebsitePaymentButton ?? true);
        }
      } catch (error) {
        console.log("Error:", error);
      }
    };

    fetchSetting();
  }, []);

  console.log(settingId, "iddd");
  console.log(selectedApp, "iddd");
  console.log(selectedWeb, "iddd");

  const handleSubmit = async () => {
    if (
      selectedWeb === "Select Web Gateway" ||
      selectedApp === "Select App Gateway"
    ) {
      alert("Please select both Web & App gateways");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.put(`updateGetwaySetting/${settingId}`, {
        upiGatewayWeb: selectedWeb,
        upiGateway: selectedApp,
        gatewayVisibilityWeb: webVisible,
        gatewayVisibilityApp: appVisible,
        gatewayVideoUpload: appVideoLink,
        gatewayWebViedeoUpload:webVideoLink,
        showcheckOutPageInWeb:showCheckOutPage,
        showGatewayPaymentButton: showGatewayPaymentButton,
        showWebsitePaymentButton: showWebsitePaymentButton,
      });

      console.log("Response:", response.data);
      alert("Payment gateway settings saved successfully!");
    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
  <div className="relative w-full">
  {/* Top Right Save button */}
  <button
    onClick={handleSubmit}
    disabled={loading}
    className="absolute top-4 right-4 bg-blue-600 text-white font-semibold rounded-md py-2 px-4 hover:bg-blue-700 transition disabled:bg-gray-400"
  >
    {loading ? "Saving..." : "Save Settings"}
  </button>

 <div className="relative w-full">

  {/* Save button top-right */}
  <button
    onClick={handleSubmit}
    disabled={loading}
    className="absolute top-4 right-4 bg-blue-600 text-white font-semibold rounded-md py-2 px-4 hover:bg-blue-700 transition disabled:bg-gray-400"
  >
    {loading ? "Saving..." : "Save Settings"}
  </button>

<div className="flex m-10">
  <div className="w-full max-w-xl">   

    <h2 className="text-2xl font-bold text-left mb-8 text-gray-800">
      Payment Gateway Settings
    </h2>

    <div className="space-y-6">

      {/* Visibility Toggle for Web */}
  <div>
  <label className="block font-medium mb-2 text-gray-700 text-left">
    Web Gateway Visibility
  </label>

  <div
    onClick={() => setWebVisible(!webVisible)}
    className={`w-14 h-7 flex items-center rounded-full p-1 cursor-pointer transition ${
      webVisible ? "bg-green-600" : "bg-gray-300"
    }`}
  >
    <div
      className={`bg-white w-6 h-6 rounded-full shadow-md transform transition ${
        webVisible ? "translate-x-7" : "translate-x-0"
      }`}
    />
  </div>
</div>

      {/* Visibility Toggle for App */}
    <div>
  <label className="block font-medium mb-2 text-gray-700 text-left">
    App Gateway Visibility
  </label>

  <div
    onClick={() => setAppVisible(!appVisible)}
    className={`w-14 h-7 flex items-center rounded-full p-1 cursor-pointer transition ${
      appVisible ? "bg-green-600" : "bg-gray-300"
    }`}
  >
    <div
      className={`bg-white w-6 h-6 rounded-full shadow-md transform transition ${
        appVisible ? "translate-x-7" : "translate-x-0"
      }`}
    />
  </div>  
</div>

<label className="block font-medium mb-2 text-gray-700 text-left">
    Show checkout Page in Web
  </label>

  <div
    onClick={() => setshowCheckOutPage(!showCheckOutPage)}
    className={`w-14 h-7 flex items-center rounded-full p-1 cursor-pointer transition ${
      showCheckOutPage ? "bg-green-600" : "bg-gray-300"
    }`}
  >
    <div
      className={`bg-white w-6 h-6 rounded-full shadow-md transform transition ${
        showCheckOutPage ? "translate-x-7" : "translate-x-0"
      }`}
    />
  </div>

  {/* Show Gateway Payment Button */}
  <div>
    <label className="block font-medium mb-2 text-gray-700 text-left">
      Show Gateway Payment Button
    </label>
    <div
      onClick={() => setShowGatewayPaymentButton(!showGatewayPaymentButton)}
      className={`w-14 h-7 flex items-center rounded-full p-1 cursor-pointer transition ${
        showGatewayPaymentButton ? "bg-green-600" : "bg-gray-300"
      }`}
    >
      <div
        className={`bg-white w-6 h-6 rounded-full shadow-md transform transition ${
          showGatewayPaymentButton ? "translate-x-7" : "translate-x-0"
        }`}
      />
    </div>
  </div>

  {/* Show Website Payment Button */}
  <div>
    <label className="block font-medium mb-2 text-gray-700 text-left">
      Show Website Payment Button
    </label>
    <div
      onClick={() => setShowWebsitePaymentButton(!showWebsitePaymentButton)}
      className={`w-14 h-7 flex items-center rounded-full p-1 cursor-pointer transition ${
        showWebsitePaymentButton ? "bg-green-600" : "bg-gray-300"
      }`}
    >
      <div
        className={`bg-white w-6 h-6 rounded-full shadow-md transform transition ${
          showWebsitePaymentButton ? "translate-x-7" : "translate-x-0"
        }`}
      />
    </div>
  </div>

      {/* Web Dropdown */}
      <div>
        <label className="block font-medium mb-2 text-gray-700 text-left">
          Select Web UPI Gateway
        </label>
        <button
          onClick={() => setOpenWeb(!openWeb)}
          className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-2 text-left shadow-sm hover:border-blue-500 focus:ring-2 focus:ring-blue-400"
        >
          {selectedWeb}
        </button>

        {openWeb && (
          <ul className="absolute w-full bg-white border border-gray-300 rounded-md shadow-lg mt-1 z-20">
            {options.map((option) => (
              <li
                key={option}
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => {
                  setSelectedWeb(option);
                  setOpenWeb(false);
                }}
              >
                {option}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* App Dropdown */}
      <div>
        <label className="block font-medium mb-2 text-gray-700 text-left">
          Select App UPI Gateway
        </label>
        <button
          onClick={() => setOpenApp(!openApp)}
          className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-2 text-left shadow-sm hover:border-blue-500 focus:ring-2 focus:ring-blue-400"
        >
          {selectedApp}
        </button>

        {openApp && (
          <ul className="absolute w-full bg-white border border-gray-300 rounded-md shadow-lg mt-1 z-20">
            {options.map((option) => (
              <li
                key={option}
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => {
                  setSelectedApp(option);
                  setOpenApp(false);
                }}
              >
                {option}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Video Upload */}
    <div className="space-y-4">
  <div>
    <label className="block font-medium mb-2 text-gray-700 text-left">
      Upload Video for WEB
    </label>
    <input
      type="text"
      value={webVideoLink}
      onChange={(e) => setWebVideoLink(e.target.value)}
      className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-2"
      placeholder="Add your video link"
    />
  </div>

  <div>
    <label className="block font-medium mb-2 text-gray-700 text-left">
      Upload Video for App
    </label>
    <input
      type="text"
      value={appVideoLink}
      onChange={(e) => setAppVideoLink(e.target.value)}
      className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-2"
      placeholder="Add your video link"
    />
  </div>
</div>

    </div>

  </div>
</div>

</div>

</div>


  );
};

export default PaymentSetting;
